export const RF_MERCHANT = "RF_MERCHANT";
export const RF_MERCHANT_CODE = "RF_MERCHANT_CODE";
export const RF_USER_INFO = "RF_USER_INFO";
export const RF_ORDER = "RF_ORDER";
export const RF_CARTITEMS = "RF_CARTITEMS";
export const RF_SELECTED_STORE = "RF_SELECTED_STORE";
export const RF_ADDRESS_FOOTER = "RF_ADDRESS_FOOTER";
export const RF_PREMIUM_DOMAIN = "RF_ADDRESS_FOOTER";
